/* tslint:disable */
/* eslint-disable */
/**
 * Checkout App API
 * Provides management of all checkout operations. Version 0.X is not supported in PRO and doesn\'t have all endpoints implemented.  It is intended be used for test purposes only and possibly with mock services.
 *
 * The version of the OpenAPI document: v1
 * Contact: Commerce-Purchase@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ContactType = {
    Billing: 'BILLING',
    Shipping: 'SHIPPING',
    Mailing: 'MAILING',
    Tax: 'TAX'
} as const;
export type ContactType = typeof ContactType[keyof typeof ContactType];


export function ContactTypeFromJSON(json: any): ContactType {
    return ContactTypeFromJSONTyped(json, false);
}

export function ContactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactType {
    return json as ContactType;
}

export function ContactTypeToJSON(value?: ContactType | null): any {
    return value as any;
}

